<template>
  <div id="nav" class="nav">
    <div class="nav_row">
      <div class="logo">
        <img :src="logo" alt="南京迪孚" />
      </div>
      <div class="menu">
        <div class="menu-box"  v-for="route in menusList" :key="route.path" > 
          <div class="menu-text"  v-if="!route.hidden"> 
            <router-link :to="route.path" class="menu-active">{{
              route.meta.title
            }}</router-link>
          </div>
          <div
            class="subMenu"
            :class="route.meta.title == '关于迪孚' ? 'subWidth' : ''"
            v-if="route.children"
          >
           
            <div
              class="subMenu-text"
              v-for="subRoute in route.children"
              :key="subRoute.path"
            >
              <router-link :to="subRoute.path" class="subMenuText">{{
                subRoute.meta.title
              }}</router-link>
            </div>
            <div class="subMenuBg"></div>
          </div>
        </div>
      </div>
      <!-- 之前的不符合需要手写 -->
      <!--<div>
         <el-menu :default-active="activeMenu" menu-trigger='hover' mode="horizontal">
          <template>
            <sidebar-item v-for="route in menus[0].children" :key="route.path" :item="route" :base-path="route.path" />
          </template>
        </el-menu>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import logo from "@/assets/logo.png";
export default {
  name: "Navbar",
  components: { SidebarItem },
  data() {
    return {
      menusList: [],
      logo: logo
    };
  },
  props: {},
  computed: {
    ...mapGetters(["menus"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  created() {
    console.log(this.menus);
    this.menus[0].children.forEach(element => {
      if(!element.hidden){
        this.menusList.push(element)
      }
      
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#nav .nav_row{
  width: 1100px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menu {
  display: flex;
  width: 80%;
  justify-content: space-around;
  .menu-box {
    min-width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 60px;

    .menu-text {
      min-width: 100px;
      height: 36px;
      line-height: 2;
      .router-link-exact-active {
        text-align: center;
        display: block;
        background-color: #3488fa !important;
        border-radius: 10px;
        color: #fff !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    .menu-text:hover .menu-active{
      color: #3488fa !important;
    }
    .menu-text:hover .router-link-exact-active{
      color: #fff !important;
    }
  }
  
  .subMenu {
    width: 385px;
    height: 200px;
    margin-left: 18px;
    display: none;
    position: absolute;
    top: 60px;
    .subMenu-text {
      width: 50%;
      height: 30px;
      line-height: 2;
      text-align: left;
      z-index: 11;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .subMenuText {
        margin: 0;
        padding: 0;
      }
    }
  }
  .subWidth {
    width: auto !important;
    .subMenu-text{
      width: auto !important;
    }
  }
  .menu-active {
    font-size: 18px;
  }

  .subMenuBg {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100vw;
    // min-height: 280px;
    min-height: 206px;
    background: #fff;
    display: none;
  }
  .menu-box:hover {
    .subMenuBg {
      display: block;
    }
    .subMenu {
      display: flex;
      flex-wrap: wrap;
    }
    .subWidth {
      display: flex !important;
      align-content: baseline;
      .subMenu-text{
        width: 100%;
      }
    }
  }
}
</style>

<style scoped lang="scss">
#nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  // background: -webkit-linear-gradient(left,#5749e6,#2fcfda); /* Safari 5.1-6.0 */
  // background: -o-linear-gradient(left,#5749e6,#2fcfda); /* Opera 11.1-12.0 */
  // background: -moz-linear-gradient(left,#5749e6,#2fcfda); /* Firefox 3.6-15 */
  // background: linear-gradient(left,#5749e6,#2fcfda); /* 标准语法 */
  height: 60px;
  z-index: 23233;
  line-height: 60px;
  border-bottom: 1px solid #dae8f7;
  .nav_row {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 786px;
    margin: 0 auto;
    background: transparent;
  }
  .logo {
    line-height: 60px;
    text-align: left;
    img {
      vertical-align: middle;
      width: 81px;
    }
  }
  /deep/.el-menu {
    // height:34px;
    display: flex;
    align-items: center;
    background: transparent;
  }
  /deep/.el-menu-item.is-active {
    background-color: #3488fa !important;
    a {
      color: #fff;
    }
  }
  /deep/.menu-wrapper {
    height: 34px;
    outline: none;
  }
  /deep/.el-menu-item {
    padding: 0px;
    line-height: 2.2;
    height: 34px;
    width: 84px;
    border-radius: 10px;
    box-sizing: border-box;
    a {
      display: inline-block;
      line-height: 2.2;
      height: 34px;
      font-size: 16px;
      color: #000;
      padding: 0 0.1rem;
    }
  }
  /deep/.itemTitle {
    font-size: 0.18rem;
  }
  /deep/.el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  /deep/.el-submenu {
    height: 0.8rem;
    line-height: 0.8rem;
    box-sizing: border-box;
    outline: none;
  }
  /deep/.el-submenu__title {
    height: 100%;
    font-size: 0.18rem;
    line-height: 0.8rem;
    padding: 0 0.1rem;
    i {
      font-size: 0.18rem;
    }
    span {
      padding-right: 0.2rem;
    }
  }
  /deep/.el-submenu {
    font-size: 0.18rem;
    //  width:1.1rem;
  }
  a {
    padding-bottom: 4px;
    margin: 0 0.1rem;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #105fa8;
    }
  }
  /deep/ .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: #3488fa !important;
    border-radius: 10px;
    color: #fff !important;
  }
  /deep/ .el-menu-item:focus > a,
  .el-menu-item:hover > a,
  .el-submenu:focus span,
  .el-submenu:hover span {
    color: #fff !important;
  }
}
</style>
<style>
.nest-menu a {
  font-size: 0.16rem !important;
  text-align: center;
}
.el-submenu__icon-arrow {
  right: 8px;
}
</style>
